module.exports = __webpack_public_path__ + "static/img/digicult.4f48ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/digicult.png
// module id = /sI0
// module chunks = 0